import type { SVGProps } from "react";
const SvgIconQuestion = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <path d="M512 688c-13.25 0-24-10.75-24-24v-48c0-42.42 37.47-70.27 77.13-99.76 48.56-36.1 98.77-73.42 98.77-139.7C663.9 297.42 600.02 240 512 240c-62.74 0-119.84 39.4-142.08 98.04-4.7 12.39-18.56 18.63-30.95 13.93s-18.63-18.56-13.93-30.95c14.24-37.53 39.19-69.61 72.15-92.77 33.74-23.71 73.44-36.24 114.81-36.24 53.9 0 103.7 17.69 140.23 49.82 38.48 33.84 59.67 81.69 59.67 134.73 0 40.71-13.45 76.79-41.11 110.3-22.77 27.58-51.59 49.01-77.03 67.92-29.71 22.08-57.77 42.94-57.77 61.24v48c0 13.25-10.75 24-24 24Z" />
    <circle cx={512} cy={796} r={36} />
  </svg>
);
export default SvgIconQuestion;
